import {extend} from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Post from 'flarum/common/models/Post';
import DiscussionSubmission from './components/DiscussionSubmission';

function showFieldsOnPost(post: Post) {
    return post.number() === 1;
}

export default function () {
    extend(CommentPost.prototype, 'oninit', function (this: CommentPost) {
        if (!showFieldsOnPost(this.attrs.post)) {
            return;
        }

        this.subtree.check(() => {
            const submissions = this.attrs.post.discussion().formulaireSubmissions();
            // Create a string with the submission data to all fields
            return submissions ? submissions.map(submission => JSON.stringify(submission.formData())).join(',') : '';
        });
    });

    extend(CommentPost.prototype, 'content', function (this: CommentPost, content) {
        const {post} = this.attrs;

        if (!showFieldsOnPost(post)) {
            return;
        }

        const forms = post.discussion().formulaireForms();

        if (!forms) {
            return;
        }

        const postHeaderIndex = content.findIndex((item: any) => item && item.attrs && item.attrs.className === 'Post-header');

        // Insert the new content just after the header
        // or at the very beginning if the header is not found
        content.splice(postHeaderIndex === -1 ? 0 : postHeaderIndex + 1, 0, forms.map(form => m(DiscussionSubmission, {
            form,
            discussion: post.discussion(),
        })));
    });
}
